import { MatCheckboxModule } from "@angular/material/checkbox";
import { DateAgoPipe } from "./../../services/shared/date-ago.pipe";
import { RouterModule } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  FormBuilder,
  NgForm,
  NgModel,
  Validators,
  ValidatorFn,
} from "@angular/forms";
import { LeadsComponent } from "../dashboard/lead.component";
import { NgInfiniteScrollModule } from "ngx-sentinel-infinite-scroll/ng-infinite-scroll.module";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { NgUploaderModule } from "ngx-uploader";
import { SlimLoadingBarModule } from "ng2-slim-loading-bar";
import { SweetAlert2Module } from "@toverux/ngx-sweetalert2";
import { MomentModule } from "angular2-moment/moment.module";
import { ModalModule } from "ngx-modal";
import { ModalGalleryModule } from "angular-modal-gallery";
import { Ng2AutoCompleteModule } from "ng2-auto-complete";
import { NguiAutoCompleteModule } from "@ngui/auto-complete";
import { DropdownModule as PrimeDropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";
import { NgSelectModule } from "@ng-select/ng-select";
import { QualificationModalComponent } from "./modals/qualification-modal/qualification-modal.component";
import { FeedbackModalComponent } from "./modals/feedback-modal/feedback-modal.component";

@NgModule({
  declarations: [
    LeadsComponent,
    DateAgoPipe,
    QualificationModalComponent,
    FeedbackModalComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    NgInfiniteScrollModule,
    PrimeDropdownModule,
    ButtonModule,
    InfiniteScrollModule,
    NgUploaderModule,
    SlimLoadingBarModule.forRoot(),
    SweetAlert2Module,
    RouterModule,
    MomentModule,
    ModalModule,
    ModalGalleryModule,
    Ng2AutoCompleteModule,
    NguiAutoCompleteModule,
    MatCheckboxModule,
    NgSelectModule,
  ],
  providers: [HttpClientModule, FormBuilder],
  bootstrap: [LeadsComponent],
  exports: [LeadsComponent, SlimLoadingBarModule],
})
export class LeadsModule {}



// WEBPACK FOOTER //
// ./src/app/lead/dashboard/lead.module.ts